import { ConditionEqualityType } from "../../../../../../api/types/fieldConfigurationTypes.ts";
import type {
  BuildBalanceSheetExportRequest,
  BuildBalanceSheetReportRequest,
  DimensionDescriptor,
  ExportParameters,
} from "../../../../../../api/types/svTypes.ts";

const getParameterName = (dimensionName: string, dimensions: DimensionDescriptor[]): string =>
  dimensions.find((dimension) => dimension.name === dimensionName)?.caption ?? dimensionName;

const buildParameters = (
  request: BuildBalanceSheetReportRequest,
  dimensions: DimensionDescriptor[]
): ExportParameters[] => {
  return request.conditions.map((condition) => ({
    name: getParameterName(condition.filter.dimensionName, dimensions),
    equality: condition.filter.equalityType ?? ConditionEqualityType.Equal,
    values: condition.filter.values,
  }));
};

export const buildBalanceSheetExportRequest = (
  request: BuildBalanceSheetReportRequest,
  dimensions: DimensionDescriptor[],
  withParameters: boolean,
  exportValuesAsDisplayed: boolean
): BuildBalanceSheetExportRequest => {
  return {
    buildConfig: request,
    exportConfig: {
      withParameters,
      exportValuesAsDisplayed,
      parameters: withParameters ? buildParameters(request, dimensions) : [],
    },
  };
};
